function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M722.969,52.715S535.784-16.471,594.9,241.019c0,0,10.747,34.034,101.205,38.064,0,0,8.508-3.135,7.613-26.421C703.713,252.662,679.531,66.644,722.969,52.715Z",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M722.969,52.715s19.7,5.15,7.612,210.7l1.094,27.921s24.431,8.8,38.761,7.9c0,0,26.421,1.344,26.421-20.151,0,0,.9-75.68-9.852-85.532",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M594.9,241.019l0.43,28.731,1.064,71.125,1.361,90.965,1.321,88.251,0.942,62.982c0.206,13.757,1.512,26.525,8.56,38.835a90.3,90.3,0,0,0,27.908,29.761C654.8,664,676.735,668.78,698.238,672.046c14.054,2.135,28.1,4.328,42.219,6.014s28.22,3.728,42.24.4c14.452-3.43,29.62-10.763,35.62-25.267a37.839,37.839,0,0,0,2.722-14.073V326.1c0,1.878-12.942,2.814-13.85,2.887-21.786,1.757-44.137-1.039-65.7-3.859-20.876-2.73-41.631-6.289-62.394-9.761-18.68-3.123-38.345-5.061-54.887-15.091-15-9.1-27.184-20.985-29.013-39.027",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M726.325,57.844l-3.356.917c-31.347,7.612-19.7,150.911-19.7,150.911,4.47,12.808,8.465,26.082,9.893,39.623,0.661,6.271,1.263,13.042-.788,19.12a26.064,26.064,0,0,1-7.82,11.525c-4.274,3.605-8.552,7.243-12.7,11.01,32.641,5.551,65,12.347,98,14.907,7.2,0.558,14.9.113,21.471-3.161,6.858-3.418,11.368-10.77,16.563-16.216",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M701.393,170.238l1.586,1.722c30.613,29.555,28.672,70.786,28.672,70.786s3.968-43.358,7.215-48.284",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M733.181,201.569c0.007-.225-9.1-24.579-31.788-42.065",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M720.358,179.1s7.43-58.2-3.824-116.365",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 9.284,
  y1: 53.81,
  x2: 116.097,
  y2: 64.172,
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.328,
  cy: 151.46,
  rx: 24.07,
  ry: 8.464,
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M818.155,653.563l14.527-14.889s3.134,0.448,4.926-25.973V306.847L821.039,326.1",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M837.608,306.847L833.8,299.3v-5.1s-4.225-14.106-36.929-21.382",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref12 = /*#__PURE__*/React.createElement("polygon", {
  points: "245.274 559.113 245.274 579.936 251.978 572.883 251.978 552.06 245.274 559.113",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M837.608,405.589c-3.384,4.245-10.244,9.975-11.89,14.991a11.923,11.923,0,0,0-.4,3.685c-0.126,28.978-.024,57.959-0.024,86.938V637.33l11.368-13.882",
  transform: "translate(-582.607 -43.512)",
  fill: "none",
  stroke: "#54b0ff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
});

function SvgIqos24({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 255.751,
    height: 637.481,
    viewBox: "0 0 255.751 637.481",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iqos_24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIqos24);
export default __webpack_public_path__ + "static/media/iqos_24.9b511abc21e871aaf12b76bf503aae6a.svg";
export { ForwardRef as ReactComponent };